export default {
    "name": "VehicleBreakEvenReportData",
    "kind": "HoudiniQuery",
    "hash": "d347bb858a9847f1fc6db1929042428e1b6ce135a641c583c73d827f67a69f09",

    "raw": `query VehicleBreakEvenReportData($vehicleId: Int!) {
  vehicle(id: $vehicleId) {
    reportData {
      breakEven {
        date
        expensesCount
        expensesTotal
        salesCount
        salesTotal
        costOfGoodsSoldTotal
      }
    }
    id
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "vehicle": {
                "type": "Vehicle",
                "keyRaw": "vehicle(id: $vehicleId)",
                "nullable": true,

                "selection": {
                    "fields": {
                        "reportData": {
                            "type": "VehicleReportData",
                            "keyRaw": "reportData",

                            "selection": {
                                "fields": {
                                    "breakEven": {
                                        "type": "VehicleBreakEvenReportData",
                                        "keyRaw": "breakEven",

                                        "selection": {
                                            "fields": {
                                                "date": {
                                                    "type": "Date",
                                                    "keyRaw": "date",
                                                    "visible": true
                                                },

                                                "expensesCount": {
                                                    "type": "Int",
                                                    "keyRaw": "expensesCount",
                                                    "visible": true
                                                },

                                                "expensesTotal": {
                                                    "type": "Decimal2",
                                                    "keyRaw": "expensesTotal",
                                                    "visible": true
                                                },

                                                "salesCount": {
                                                    "type": "Int",
                                                    "keyRaw": "salesCount",
                                                    "visible": true
                                                },

                                                "salesTotal": {
                                                    "type": "Decimal2",
                                                    "keyRaw": "salesTotal",
                                                    "visible": true
                                                },

                                                "costOfGoodsSoldTotal": {
                                                    "type": "Decimal2",
                                                    "keyRaw": "costOfGoodsSoldTotal",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "vehicleId": "Int"
        },

        "types": {},
        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=a77629f4237e591cf793493efaf781eeaefae89d1bc9b9b9ff2fc436a1ea1110";